import { render, staticRenderFns } from "./DashboardOrm.vue?vue&type=template&id=93a1d49a&scoped=true"
import script from "./DashboardOrm.vue?vue&type=script&lang=js"
export * from "./DashboardOrm.vue?vue&type=script&lang=js"
import style0 from "./DashboardOrm.vue?vue&type=style&index=0&id=93a1d49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a1d49a",
  null
  
)

export default component.exports